<app-header></app-header>

<div class="flex">
  <app-sidebar optionMenu="7"></app-sidebar>

  <div class="p-10 flex-1 relative top-[150px] left-[20px]">

    <div class="grid grid-cols-4 gap-10 max-w-6xl mx-auto">
    
      <button [routerLink]="['/home-versioner']" class="p-8 bg-white shadow hover:shadow-lg transition text-center w-[188px] h-[188px] shrink-0 rounded-[8px]">
        <img src="https://d2yoo3qu6vrk5d.cloudfront.net/pulzo-dev/RonaldImages/versionador.png" class="mx-auto mb-4 w-16">
        <p class="text-xl text-[#181818] font-[Helvetica] text-[14px] font-normal leading-[20px]">Versionador</p>
      </button>

      <button [routerLink]="['/multiformato']" class="p-8 bg-white shadow hover:shadow-lg transition text-center w-[188px] h-[188px] shrink-0 rounded-[8px]">
        <img src="https://d2yoo3qu6vrk5d.cloudfront.net/pulzo-dev/RonaldImages/multiformatoIcon.png" class="mx-auto mb-4 w-16">
        <p class="text-xl text-[#181818] font-[Helvetica] text-[14px] font-normal leading-[20px]">Multiformato</p>
      </button>

      <button [routerLink]="['/voz-ia']" class="p-8 bg-white shadow hover:shadow-lg transition text-center w-[188px] h-[188px] shrink-0 rounded-[8px]">
        <img src="https://d2yoo3qu6vrk5d.cloudfront.net/pulzo-dev/RonaldImages/boton-vozIA.png" class="mx-auto mb-4 w-16">
        <p class="text-xl text-[#181818] font-[Helvetica] text-[14px] font-normal leading-[20px]">Texto a voz</p>
      </button>

      <button [routerLink]="['/blocked-filter']" class="p-8 bg-white shadow hover:shadow-lg transition text-center w-[188px] h-[188px] shrink-0 rounded-[8px]">
        <span class="mx-auto mb-4 w-16 w-[62px] h-[62px] rounded-md flex items-center justify-center bg-[#1f5fc9]">
          <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 4H3l7 8.3V18l4 2v-7.7z"/></svg>
        </span>
        <p class="text-xl text-[#181818] font-[Helvetica] text-[14px] font-normal leading-[20px]">Filtro automático</p>
      </button>



    </div>
  </div>
</div>
